<div
  class="device-wrapper"
  [ngClass]="'device-' + (previewChannel || '').toLowerCase().replace('_', '-')"
>
  <!-- ══ EMAIL: Desktop Browser Mockup ══ -->
  <ng-container *ngIf="previewChannel === previewCase.EMAIL; else phoneFrame">
    <div class="device-email">
      <div class="email-browser">
        <div class="browser-header">
          <div class="dots"><span></span><span></span><span></span></div>
          <div class="url-bar">
            <i class="pi pi-lock" style="font-size: 10px; color: #22c55e"></i>
            mail.example.com/inbox
          </div>
        </div>
        <div class="email-meta">
          <div class="email-meta-row">
            <span class="email-meta-label">From</span>
            <span class="email-meta-value"> marutisuzuki@msil.com </span>
          </div>
          <div class="email-meta-row">
            <span class="email-meta-label">Subject</span>
            <span
              class="email-meta-value"
              [innerHTML]="templateData?.subject || '-'"
            ></span>
          </div>
        </div>
        <div
          class="email-content-wrapper"
          [style.background-color]="emailMasterJson?.templateBackgroundColor"
        >
          <div class="canvas-inner" *ngIf="emailMasterJson?.layout?.rows">
            <ng-container
              *ngFor="let row of emailMasterJson.layout.rows; let i = index"
            >
              <div
                class="row"
                [attr.data-row-index]="i"
                [ngClass]="{ 'empty-row': checkContentInfo(i) }"
              >
                <ng-container
                  *ngFor="let column of row.columns; let colIndex = index"
                >
                  <div
                    class="column"
                    [style.width]="column.screenPercentage"
                    [ngStyle]="{
                      'align-items': 'center',
                      display: 'flex',
                      'justify-content': isTextContent(column.content)
                        ? 'flex-start'
                        : isButtonContent(column.content)
                          ? column.content.properties.alignment?.toLowerCase() ||
                            'center'
                          : 'center',
                    }"
                  >
                    <!-- Image -->
                    <div *ngIf="isImageContent(column.content)" class="w-100">
                      <a
                        *ngIf="column.content.properties.mediaUrl; else noLink"
                        [attr.href]="column.content.properties.mediaUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          [src]="
                            column.content.properties.url ||
                            'assets/svg/common/nopreview.svg'
                          "
                          [style.width.%]="100"
                        />
                      </a>
                      <ng-template #noLink>
                        <img
                          [src]="
                            column.content.properties.url ||
                            'assets/svg/common/nopreview.svg'
                          "
                          [style.width.%]="100"
                        />
                      </ng-template>
                    </div>

                    <!-- Text -->
                    <div *ngIf="isTextContent(column.content)" class="w-100">
                      <div
                        class="text-content ql-editor"
                        [innerHTML]="
                          getUpdatedFormNameContent(column.content.properties)
                            | linkify
                        "
                      ></div>
                    </div>

                    <!-- Button -->
                    <div
                      *ngIf="isButtonContent(column.content)"
                      class="w-100"
                      [ngStyle]="{
                        'align-items': 'center',
                        display: 'flex',
                        'justify-content':
                          column.content.properties.alignment?.toLowerCase() ||
                          'center',
                      }"
                    >
                      <ng-container
                        *ngIf="
                          column.content.properties.style === 'Upload Image';
                          else regularStyle
                        "
                      >
                        <a
                          [attr.href]="
                            getFormEmailHref(column.content.properties)
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                          (click)="
                            !getHref(
                              column.content.properties.actionUrl?.trim()
                            ) && !column.content.properties.selectedWebForm
                              ? $event.preventDefault()
                              : null
                          "
                        >
                          <img
                            [src]="
                              column.content.properties.imageUrl ||
                              'assets/svg/common/nopreview.svg'
                            "
                            class="btn-image"
                            [ngClass]="{
                              small: column.content.properties.size === 'Small',
                              medium:
                                column.content.properties.size === 'Medium',
                              large: column.content.properties.size === 'Large',
                            }"
                            [style]="{
                              'background-color': 'transparent',
                              color: 'black',
                            }"
                          />
                        </a>
                      </ng-container>
                      <ng-template #regularStyle>
                        <a
                          [attr.href]="
                            getFormEmailHref(column.content.properties)
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                          (click)="
                            !getHref(
                              column.content.properties.actionUrl?.trim()
                            ) && !column.content.properties.selectedWebForm
                              ? $event.preventDefault()
                              : null
                          "
                        >
                          <button
                            class="p-button"
                            [style]="{
                              'background-color':
                                column.content.properties.backgroundColor,
                              color: column.content.properties.textColor,
                            }"
                            [ngClass]="
                              getButtonStyleClasses(column.content.properties)
                            "
                          >
                            {{ column.content.properties.text }}
                          </button>
                        </a>
                      </ng-template>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="emailMasterJson?.layout?.footer">
              <div
                class="footer-content ql-editor text-content"
                [innerHTML]="emailMasterJson.layout.footer"
              ></div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ══ PHONE FRAME (all other channels) ══ -->
  <ng-template #phoneFrame>
    <div class="phone-shell">
      <div class="phone-frame">
        <div class="screen">
          <!-- Dynamic Island notch -->
          <div class="dynamic-island"></div>

          <!-- iOS Status Bar -->
          <div class="status-bar">
            <span class="time">9:41</span>
            <div class="icons">
              <i class="pi pi-wifi"></i>
              <i class="pi pi-bolt"></i>
            </div>
          </div>

          <!-- WhatsApp Header -->
          <div
            class="app-header whatsapp-header"
            *ngIf="previewChannel === previewCase.WHATSAPP"
          >
            <i class="pi pi-arrow-left header-back"></i>
            <div class="avatar wa-avatar"><i class="pi pi-building"></i></div>
            <div class="info">
              <div class="name">
                Maruti Suzuki
                <i
                  class="pi pi-verified"
                  style="color: #25d366; font-size: 11px"
                ></i>
              </div>
              <div class="status">Business Account</div>
            </div>
            <div class="actions">
              <i class="pi pi-video"></i>
              <i class="pi pi-phone"></i>
            </div>
          </div>

          <!-- SMS Header -->
          <div
            class="app-header sms-header"
            *ngIf="previewChannel === previewCase.SMS"
          >
            <div class="header-content">
              <div class="ms-avatar">MS</div>
              <div class="name-bar">
                Maruti Suzuki <i class="pi pi-chevron-right"></i>
              </div>
            </div>
          </div>

          <!-- RCS Header -->
          <div
            class="app-header rcs-header"
            *ngIf="previewChannel === previewCase.RCS"
          >
            <i class="pi pi-arrow-left header-back"></i>
            <div class="avatar rcs-avatar"><i class="pi pi-verified"></i></div>
            <div class="info">
              <div class="name">Maruti Suzuki</div>
              <div class="status">RCS Business Messaging</div>
            </div>
            <div class="actions"><i class="pi pi-ellipsis-v"></i></div>
          </div>

          <!-- Push: Lock screen -->
          <div
            class="push-lock-screen"
            *ngIf="previewChannel === previewCase.PUSH_NOTIFICATION"
          >
            <i class="pi pi-lock lock-icon"></i>
            <div class="lock-time">9:41</div>
            <div class="lock-date">Monday, March 24</div>
          </div>

          <!-- ═══════════════════════════════════════
               SCROLLABLE MESSAGES
               ═══════════════════════════════════════ -->
          <div
            class="scrollable-content"
            [class.wa-carousel-mode]="isWhatsAppCarousel && previewChannel === previewCase.WHATSAPP"
          >
            <!-- ── WHATSAPP ── -->
            <ng-container *ngIf="previewChannel === previewCase.WHATSAPP">
              <ng-container *ngIf="!isWhatsAppCarousel; else whatsAppCarousel">
                <div class="whatsapp-bubble">
                  <!-- media -->
                  <ng-container *ngIf="mediaURL">
                    <!-- Static media -->
                    <div
                      class="media-container"
                      *ngIf="isValidMediaUrl(mediaURL)"
                    >
                      <img
                        *ngIf="mediaType === 'image'"
                        [src]="mediaURL"
                        alt="media"
                      />
                      <video
                        *ngIf="mediaType === 'video'"
                        [src]="mediaURL"
                        controls
                      ></video>
                      <div
                        *ngIf="mediaType === 'doc' || mediaType === 'document'"
                        class="doc-media"
                      >
                        <i
                          class="pi pi-file-pdf"
                          style="font-size: 1.8rem; color: #ef4444"
                        ></i>
                        <span class="doc-name">{{
                          getPdfFileNameFromUrl(mediaURL)
                        }}</span>
                      </div>
                    </div>
                    <!-- Dynamic media placeholder -->
                    <div
                      class="media-container wa-dynamic-media"
                      *ngIf="!isValidMediaUrl(mediaURL)"
                      [class.media-focused]="isMediaFocused"
                    >
                      <div class="dynamic-media-placeholder">
                        <i
                          class="pi pi-image"
                          style="
                            font-size: 1.6rem;
                            color: #128c7e;
                            opacity: 0.7;
                          "
                        ></i>
                        <span
                          style="
                            font-size: 11px;
                            color: #128c7e;
                            font-weight: 600;
                            margin-top: 4px;
                          "
                          >Dynamic Media</span
                        >
                      </div>
                    </div>
                  </ng-container>
                  <!-- text -->
                  <div
                    class="text-content"
                    [innerHTML]="displayedWhatsAppHtml | linkify"
                  ></div>
                  <div
                    class="expand-btn-wrapper"
                    *ngIf="whatsappShouldShowReadMore"
                  >
                    <span
                      class="expand-toggle"
                      (click)="toggleText()"
                      role="button"
                      tabindex="0"
                      (keydown)="$event.preventDefault()"
                    >
                      {{ isTextExpanded ? "Read less" : "Read more" }}
                    </span>
                  </div>
                  <!-- footer -->
                  <div
                    class="bubble-footer"
                    *ngIf="templateData?.whatsAppTemplates?.[0]?.footer"
                  >
                    {{ templateData.whatsAppTemplates[0].footer }}
                  </div>
                  <!-- timestamp -->
                  <div class="timestamp">
                    <span>9:41 AM</span>
                    <i
                      class="pi pi-check-circle"
                      style="font-size: 9px; color: #53bdeb"
                    ></i>
                  </div>
                  <!-- buttons -->
                  <div class="buttons-container" *ngIf="buttons.length">
                    <ng-container *ngFor="let btn of buttons; let i = index">
                      <div
                        class="action-btn"
                        *ngIf="i < 3 && (buttons.length <= 3 || i < 2)"
                        role="button"
                        tabindex="0"
                        (click)="openButtonAction(btn)"
                        (keydown.enter)="openButtonAction(btn)"
                        [ngClass]="{
                          'chip-focused': btn._highlightState === 'focused',
                          'chip-mapped': btn._highlightState === 'mapped'
                        }"
                      >
                        <i
                          class="pi pi-external-link"
                          *ngIf="isUrlButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-reply"
                          *ngIf="isReplyButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-phone"
                          *ngIf="isCallButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-map-marker"
                          *ngIf="isLocationButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-calendar"
                          *ngIf="isCalendarButton(btn.buttonAction)"
                        ></i>
                        <span [innerHTML]="getButtonLabel(btn)"></span>
                      </div>
                      <div
                        class="action-btn"
                        *ngIf="i === 2 && buttons.length > 3"
                        role="button"
                        tabindex="0"
                        (keydown)="$event.preventDefault()"
                      >
                        <i class="pi pi-list"></i> See all options
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- WA carousel -->
              <ng-template #whatsAppCarousel>
                <!-- WA Carousel Bubble (body text from CAROUSEL_BUBBLE entry) -->
                <div
                  class="whatsapp-bubble"
                  *ngIf="whatsAppCarouselBubble"
                >
                  <div
                    class="text-content"
                    *ngIf="whatsAppCarouselBubble.content"
                    [innerHTML]="displayedWhatsAppHtml | linkify"
                  ></div>
                  <div
                    class="bubble-footer"
                    *ngIf="whatsAppCarouselBubble.footer"
                  >
                    {{ whatsAppCarouselBubble.footer }}
                  </div>
                  <div class="timestamp">
                    <span>9:41 AM</span>
                    <i
                      class="pi pi-check-circle"
                      style="font-size: 9px; color: #53bdeb"
                    ></i>
                  </div>
                </div>
                <!-- WA Carousel Cards -->
                <div class="wa-carousel">
                  <div
                    class="wa-carousel-card"
                    *ngFor="let card of whatsAppCarouselCards; let i = index"
                  >
                    <!-- Static media -->
                    <div
                      class="media-container"
                      *ngIf="card.mediaURL && isValidMediaUrl(card.mediaURL)"
                    >
                      <img
                        *ngIf="isCarouselImage(card)"
                        [src]="card.mediaURL"
                        alt="media"
                      />
                      <video
                        *ngIf="isCarouselVideo(card)"
                        [src]="card.mediaURL"
                        controls
                      ></video>
                      <div *ngIf="isCarouselDocument(card)" class="doc-media">
                        <i
                          class="pi pi-file-pdf"
                          style="font-size: 1.5rem; color: #ef4444"
                        ></i>
                        <span class="doc-name">{{
                          getPdfFileNameFromUrl(card.mediaURL)
                        }}</span>
                      </div>
                    </div>
                    <!-- Dynamic media placeholder -->
                    <div
                      class="media-container wa-dynamic-media"
                      *ngIf="isWaCarouselDynamicMedia(card)"
                      [class.media-focused]="isMediaFocused"
                    >
                      <div class="dynamic-media-placeholder">
                        <i
                          class="pi pi-image"
                          style="
                            font-size: 1.6rem;
                            color: #128c7e;
                            opacity: 0.7;
                          "
                        ></i>
                        <span
                          style="
                            font-size: 11px;
                            color: #128c7e;
                            font-weight: 600;
                            margin-top: 4px;
                          "
                          >Dynamic Media</span
                        >
                      </div>
                    </div>
                    <div
                      class="text-content"
                      [innerHTML]="
                        getDisplayedWhatsAppCarouselHtml(i) | linkify
                      "
                    ></div>
                    <div
                      class="expand-btn-wrapper"
                      *ngIf="
                        getWhatsAppCarouselCardPlainTextLength(i) >
                        whatsappMaxLetterCount
                      "
                    >
                      <span
                        class="expand-toggle"
                        (click)="toggleText()"
                        (keydown)="$event.preventDefault()"
                        >{{ isTextExpanded ? "Read less" : "Read more" }}</span
                      >
                    </div>
                    <div class="buttons-container" *ngIf="card.buttons?.length">
                      <ng-container
                        *ngFor="let btn of card.buttons; let bi = index"
                      >
                        <div
                          class="action-btn"
                          *ngIf="bi < 3 && (card.buttons.length <= 3 || bi < 2)"
                          role="button"
                          tabindex="0"
                          (click)="openButtonAction(btn)"
                          (keydown.enter)="openButtonAction(btn)"
                          [ngClass]="{
                            'chip-focused': btn._highlightState === 'focused',
                            'chip-mapped': btn._highlightState === 'mapped'
                          }"
                        >
                          <i
                            class="pi pi-external-link"
                            *ngIf="isUrlButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-reply"
                            *ngIf="isReplyButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-phone"
                            *ngIf="isCallButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-map-marker"
                            *ngIf="isLocationButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-calendar"
                            *ngIf="isCalendarButton(btn.buttonAction)"
                          ></i>
                          <span [innerHTML]="getButtonLabel(btn)"></span>
                        </div>
                        <div
                          class="action-btn"
                          *ngIf="bi === 2 && card.buttons.length > 3"
                        >
                          <i class="pi pi-list"></i> See all options
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- ── SMS ── -->
            <div class="sms-bubble" *ngIf="previewChannel === previewCase.SMS">
              <div
                class="text-content"
                [innerHTML]="displayedSmsHtml | linkify"
              ></div>
              <div class="expand-btn-wrapper" *ngIf="smsShouldShowReadMore">
                <span
                  class="expand-toggle"
                  (click)="toggleText()"
                  role="button"
                  tabindex="0"
                  (keydown)="$event.preventDefault()"
                >
                  {{ isTextExpanded ? "Read less" : "Read more" }}
                </span>
              </div>
            </div>

            <!-- ══════════════════════════════════════════════════════════
                 RCS  –  mirrors RcsTemplatePreviewComponent exactly
                 ══════════════════════════════════════════════════════════ -->
            <ng-container *ngIf="previewChannel === previewCase.RCS">
              <!-- ── Standalone rich card ── -->
              <ng-container *ngIf="!isRcsCarousel && rcsFormData">
                <!-- With media (HORIZONTAL or VERTICAL orientation, has isMedia) -->
                <div
                  class="rcs-bubble"
                  *ngIf="
                    rcsFormData.isMedia &&
                    (rcsFormData.orientation === orientationEnum.HORIZONTAL ||
                      rcsFormData.orientation === orientationEnum.VERTICAL)
                  "
                  [ngClass]="{
                    'layout-horizontal':
                      rcsFormData.orientation === orientationEnum.HORIZONTAL,
                    'layout-left':
                      rcsFormData.orientation === orientationEnum.HORIZONTAL &&
                      rcsFormData.layout === rcsLayoutEnum.LEFT,
                    'layout-right':
                      rcsFormData.orientation === orientationEnum.HORIZONTAL &&
                      rcsFormData.layout === rcsLayoutEnum.RIGHT,
                  }"
                >
                  <!-- Media column (always visible, not scrolled) -->
                  <div
                    class="media-container"
                    [ngClass]="{
                      'media-layout':
                        rcsFormData.orientation === orientationEnum.HORIZONTAL,
                      'text-center':
                        rcsFormData.orientation === orientationEnum.VERTICAL,
                    }"
                  >
                    <!-- Static image -->
                    <img
                      class="preview-media"
                      *ngIf="
                        (rcsFormData.mediaType === mediaTypeEnum.IMAGE ||
                          rcsFormData.mediaType === 'IMAGE') &&
                        rcsFormData.mediaUrl &&
                        !rcsFormData.mediaUrl?.includes('#mediaUrl')
                      "
                      [src]="rcsFormData.mediaUrl"
                      alt="preview"
                    />

                    <!-- Video thumbnail (static) — show play icon + thumb image -->
                    <div
                      *ngIf="hasVideoThumbnail(rcsFormData)"
                      style="
                        position: relative;
                        display: inline-block;
                        width: 100%;
                      "
                    >
                      <img
                        class="preview-media"
                        [src]="rcsFormData.videoThumbnail"
                        alt="thumbnail"
                      />
                      <i class="bi bi-play-circle thumbnail-icon"></i>
                    </div>

                    <!-- Dynamic thumbnail placeholder -->
                    <div
                      class="dynamic-thumbnail"
                      [ngClass]="{
                        'horizontal-media':
                          rcsFormData.orientation ===
                          orientationEnum.HORIZONTAL,
                        'media-focused': isMediaFocused
                      }"
                      *ngIf="isDynamicThumbnail(rcsFormData)"
                    >
                      <p class="thumbnail-text">Dynamic Thumbnail</p>
                    </div>

                    <!-- Dynamic media placeholder (no thumbnail, no static URL) -->
                    <div
                      class="dynamic-thumbnail"
                      [ngClass]="{
                        'horizontal-media':
                          rcsFormData.orientation ===
                          orientationEnum.HORIZONTAL,
                        'media-focused': isMediaFocused
                      }"
                      *ngIf="isDynamicMedia(rcsFormData)"
                    >
                      <p class="thumbnail-text">Dynamic Media</p>
                    </div>

                    <!-- PDF document -->
                    <div
                      class="doc-media"
                      [ngClass]="{
                        'horizontal-media':
                          rcsFormData.orientation ===
                          orientationEnum.HORIZONTAL,
                      }"
                      *ngIf="
                        rcsFormData.mediaType === mediaTypeEnum.DOC &&
                        rcsFormData.mediaUrl &&
                        !rcsFormData.mediaUrl?.includes('#mediaUrl1#')
                      "
                    >
                      <i
                        class="pi pi-file-pdf"
                        style="font-size: 1.8rem; color: #ef4444"
                      ></i>
                      <span class="doc-name" [title]="rcsPdfFileName">
                        {{ rcsPdfFileName }}
                      </span>
                    </div>
                  </div>
                  <!-- /media-container -->

                  <!-- Content + buttons (inner scroll wrapper) -->
                  <div class="rcs-bubble-inner-scroll">
                    <div
                      [ngClass]="
                        rcsFormData.orientation === orientationEnum.HORIZONTAL
                          ? 'rcs-horizontal-content'
                          : 'rcs-vertical-content'
                      "
                    >
                      <ng-container
                        *ngTemplateOutlet="rcsContentAndButtons"
                      ></ng-container>
                    </div>
                  </div>
                </div>
                <!-- /rcs-bubble with media -->

                <!-- Without media (text-only card) -->
                <div
                  class="rcs-bubble rcs-bubble-text-only"
                  *ngIf="!rcsFormData.isMedia"
                >
                  <div class="rcs-bubble-inner-scroll">
                    <ng-container
                      *ngTemplateOutlet="rcsContentAndButtons"
                    ></ng-container>
                  </div>
                </div>

                <!-- Shared content + buttons template -->
                <ng-template #rcsContentAndButtons>
                  <!-- Text area: clipped by CSS max-height when not expanded -->
                  <div
                    class="rcs-content-wrapper"
                    [class.rcs-expanded]="isTextExpanded"
                    [class.has-read-more]="shouldShowRcsReadMore"
                  >
                    <div
                      class="card-title"
                      *ngIf="rcsFormData.cardTitle || rcsFormData.title"
                    >
                      <span [innerHTML]="displayedRcsCardTitle"></span>
                    </div>
                    <div
                      class="text-content rcs-text-clip"
                      *ngIf="displayedRcsHtml"
                    >
                      <span [innerHTML]="displayedRcsHtml"></span>
                    </div>
                  </div>

                  <!-- Read more link — shown when text is long, sits between text and chips -->
                  <div
                    class="expand-btn-wrapper rcs-expand"
                    *ngIf="shouldShowRcsReadMore"
                  >
                    <span
                      class="expand-toggle"
                      (click)="toggleText()"
                      role="button"
                      tabindex="0"
                      (keydown)="$event.preventDefault()"
                    >
                      {{ isTextExpanded ? "Read less" : "Read more" }}
                    </span>
                  </div>

                  <!-- CTA chips — ALWAYS visible, never clipped, horizontal scroll -->
                  <div
                    class="chips-container"
                    *ngIf="
                      rcsFormData.isMedia && rcsFormData.buttonRequests?.length
                    "
                  >
                    <ng-container
                      *ngFor="
                        let btn of rcsFormData.buttonRequests;
                        let bi = index
                      "
                    >
                      <div
                        class="rcs-chip"
                        *ngIf="
                          (btn.buttonLabel || btn.label || btn.displayText) &&
                          bi < 4
                        "
                        role="button"
                        tabindex="0"
                        (click)="openButtonAction(btn)"
                        (keydown.enter)="openButtonAction(btn)"
                        [ngClass]="{
                          'chip-focused': btn._highlightState === 'focused',
                          'chip-mapped': btn._highlightState === 'mapped',
                        }"
                      >
                        <i
                          class="pi pi-map-marker"
                          *ngIf="isLocationButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-phone"
                          *ngIf="isCallButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-globe"
                          *ngIf="isUrlButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-calendar"
                          *ngIf="isCalendarButton(btn.buttonAction)"
                        ></i>
                        <i
                          class="pi pi-reply"
                          *ngIf="isReplyButton(btn.buttonAction)"
                        ></i>
                        <span [innerHTML]="getButtonLabel(btn)"></span>
                      </div>
                    </ng-container>
                  </div>
                </ng-template> </ng-container
              ><!-- /!isRcsCarousel -->

              <!-- Bottom CTA bar for text-only (no-media) cards — mirrors .template-preview-cta-container in legacy -->
              <div
                class="rcs-cta-bar"
                *ngIf="
                  !isRcsCarousel &&
                  rcsFormData &&
                  !rcsFormData.isMedia &&
                  rcsFormData.buttonRequests?.length
                "
              >
                <ng-container *ngFor="let btn of rcsFormData.buttonRequests">
                  <div
                    class="rcs-user-button"
                    *ngIf="btn.buttonLabel || btn.label || btn.displayText"
                    role="button"
                    tabindex="0"
                    (click)="openButtonAction(btn)"
                    (keydown.enter)="openButtonAction(btn)"
                    [ngClass]="{
                      'chip-focused': btn._highlightState === 'focused',
                      'chip-mapped': btn._highlightState === 'mapped',
                    }"
                  >
                    <i
                      class="pi pi-map-marker"
                      *ngIf="isLocationButton(btn.buttonAction)"
                    ></i>
                    <i
                      class="pi pi-phone"
                      *ngIf="isCallButton(btn.buttonAction)"
                    ></i>
                    <i
                      class="pi pi-globe"
                      *ngIf="isUrlButton(btn.buttonAction)"
                    ></i>
                    <i
                      class="pi pi-calendar"
                      *ngIf="isCalendarButton(btn.buttonAction)"
                    ></i>
                    <i
                      class="pi pi-reply"
                      *ngIf="isReplyButton(btn.buttonAction)"
                    ></i>
                    <span
                      [title]="getButtonLabel(btn)"
                      [innerHTML]="getButtonLabel(btn)"
                    ></span>
                  </div>
                </ng-container>
              </div>

              <!-- ── RCS Carousel ── -->
              <div class="rcs-carousel" *ngIf="isRcsCarousel">
                <div
                  class="carousel-card"
                  *ngFor="let card of rcsCarouselUICards; let i = index"
                >
                  <!-- Static image -->
                  <div
                    class="media-container"
                    *ngIf="
                      card.mediaURL && !card.mediaURL?.includes('#mediaUrl')
                    "
                  >
                    <img
                      class="preview-media"
                      *ngIf="
                        card.mediaType.toLowerCase() ===
                        mediaTypeEnum.IMAGE.toLowerCase()
                      "
                      [src]="card.mediaURL"
                      alt="preview"
                    />
                    <video
                      controls
                      controlsList="nodownload"
                      class="preview-media"
                      *ngIf="isCarouselVideoPlayable(card)"
                    >
                      <source [src]="card.mediaURL" type="video/mp4" />
                      <track
                        kind="subtitles"
                        src=""
                        srclang="en"
                        label="English subtitles"
                      />
                    </video>
                  </div>

                  <!-- Video thumbnail (static) -->
                  <div
                    class="media-container"
                    *ngIf="hasCarouselVideoThumbnail(card)"
                    style="position: relative"
                  >
                    <img
                      class="preview-media"
                      [src]="card.videoThumbnail"
                      alt="thumbnail"
                    />
                    <i class="bi bi-play-circle thumbnail-icon"></i>
                  </div>

                  <!-- Dynamic thumbnail placeholder -->
                  <div
                    class="dynamic-thumbnail d-flex align-items-center justify-content-center"
                    *ngIf="isCarouselDynamicThumbnail(card)"
                    [class.media-focused]="isMediaFocused"
                  >
                    <p class="thumbnail-text">Dynamic Thumbnail</p>
                  </div>

                  <!-- Dynamic media placeholder -->
                  <div
                    class="dynamic-thumbnail d-flex align-items-center justify-content-center"
                    *ngIf="isCarouselDynamicMedia(card)"
                    [class.media-focused]="isMediaFocused"
                  >
                    <p class="thumbnail-text">Dynamic Media</p>
                  </div>

                  <!-- Content -->
                  <div class="rcs-content-wrapper">
                    <div
                      class="card-title"
                      *ngIf="card.cardTitle || card.title"
                    >
                      <span>{{
                        (card.cardTitle || card.title).length > 25
                          ? (card.cardTitle || card.title).slice(0, 25) + "..."
                          : card.cardTitle || card.title
                      }}</span>
                    </div>
                    <div
                      class="text-content"
                      *ngIf="card.content || rcsCarouselHighlightedContents[i]"
                    >
                      <span
                        [innerHTML]="getDisplayedRcsCarouselHtml(i) | linkify"
                      ></span>
                    </div>

                    <!-- Carousel card buttons -->
                    <div class="chips-container" *ngIf="card.buttons?.length">
                      <ng-container
                        *ngFor="let btn of card.buttons; let bj = index"
                      >
                        <div
                          class="rcs-chip"
                          *ngIf="
                            (btn.label || btn.buttonLabel || btn.displayText) &&
                            bj < 4
                          "
                          role="button"
                          tabindex="0"
                          (click)="openButtonAction(btn)"
                          (keydown.enter)="openButtonAction(btn)"
                          [ngClass]="{
                            'rcs-chip-1': bj === 0,
                            'rcs-chip-2': bj === 1,
                            'rcs-chip-3': bj === 2,
                            'rcs-chip-4': bj === 3,
                            'chip-focused': btn._highlightState === 'focused',
                            'chip-mapped': btn._highlightState === 'mapped'
                          }"
                        >
                          <i
                            class="pi pi-map-marker"
                            *ngIf="isLocationButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-phone"
                            *ngIf="isCallButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-globe"
                            *ngIf="isUrlButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-calendar"
                            *ngIf="isCalendarButton(btn.buttonAction)"
                          ></i>
                          <i
                            class="pi pi-reply"
                            *ngIf="isReplyButton(btn.buttonAction)"
                          ></i>
                          <span
                            [title]="getButtonLabel(btn)"
                            [innerHTML]="getButtonLabel(btn)"
                          ></span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- /carousel-card -->
              </div>
              <!-- /rcs-carousel --> </ng-container
            ><!-- /RCS -->

            <!-- ── PUSH NOTIFICATION ── -->
            <div
              class="push-notification-card"
              *ngIf="previewChannel === previewCase.PUSH_NOTIFICATION"
            >
              <div class="push-header">
                <div class="app-icon">MS</div>
                <div class="app-name">Maruti Suzuki</div>
                <div class="time-ago">now</div>
              </div>
              <div class="push-body">
                <div class="push-text">
                  <div class="push-title">{{ pushNotificationTitle }}</div>
                  <div
                    class="push-desc"
                    [innerHTML]="displayedPushHtml | linkify"
                  ></div>
                   <div class="expand-btn-wrapper" *ngIf="pushShouldShowReadMore">
                    <span
                      class="expand-toggle"
                      (click)="toggleText()"
                      role="button"
                      tabindex="0"
                      (keydown)="$event.preventDefault()"
                    >
                      {{ isTextExpanded ? "Read less" : "Read more" }}
                    </span>
                  </div>
                </div>
                <div
                  class="push-media"
                  *ngIf="mediaURL && isValidMediaUrl(mediaURL)"
                >
                  <img [src]="mediaURL" alt="media" />
                </div>
              </div>
            </div>
          </div>
          <!-- end .scrollable-content -->

          <!-- ── Message Input Bar ── -->
          <div
            class="message-input-bar"
            *ngIf="
              previewChannel === previewCase.SMS ||
              previewChannel === previewCase.WHATSAPP ||
              previewChannel === previewCase.RCS
            "
          >
            <i class="pi pi-plus icon-btn"></i>
            <div class="input-box">
              <span>Message</span>
              <i class="pi pi-face-smile" style="font-size: 13px"></i>
            </div>
            <i class="pi pi-microphone icon-btn"></i>
          </div>

          <!-- ── Home Indicator ── -->
          <div class="home-indicator"></div>
        </div>
        <!-- end .screen -->
      </div>
      <!-- end .phone-frame -->
    </div>
    <!-- end .phone-shell -->
  </ng-template>
</div>
